module.exports = __webpack_public_path__ + "static/media/Food_Seafood_Frozen.095d30cc.jpg";